import { Component, ChangeDetectionStrategy, Input, ChangeDetectorRef, OnInit, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { ObjectTypes } from '../../../enums/objectTypes';
import { SuggestedRiskViewModel } from 'src/app/modules/risk/models/SuggestedRiskViewModel';

enum CarouselDirection {
  Forward = 'forward',
  Backward = 'backward'
}

@Component({
    selector: 'app-carousel',
    templateUrl: './carousel.component.html',
    styleUrls: ['./carousel.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CarouselComponent implements OnInit, OnChanges {
  @Input() title: string;
  @Input() items: SuggestedRiskViewModel[] = [];
  @Input() objectType: ObjectTypes;
  @Input() itemsPerPage = 4;
  @Input() useAutoplay = false;
  @Input() showIndicators = true;
  @Input() isWithinAddRiskModal: boolean = false;

  @Output() selectedItem = new EventEmitter();
  @Output() prefillFormEvent = new EventEmitter();

  public currentItems: SuggestedRiskViewModel[] = [];
  public currentPage: number = 0;
  public totalPages: number = 0;
  public totalPagesArray: number[] = [];
  public animateForward: boolean = false;
  public animateBackward: boolean = false;
  public objectTypes = ObjectTypes;
  public autoplayDelay: number = 3000;
  public autoplayInterval: any;
  public isAutoplay: boolean = false;
  public selectedPrefilledCard: SuggestedRiskViewModel;

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  ngOnInit() {
    this.initCarouselView();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.items || changes?.itemsPerPage?.currentValue !== changes?.itemsPerPage?.previousValue) {
      this.initCarouselView();
    }
  }

  get isItFirst(): boolean {
    return this.currentPage === 0;
  }

  get isItLast(): boolean {
    return this.currentPage === this.totalPagesArray.length-1;
  }

  public initCarouselView(): void {
    this.calculateTotalPages();
    this.updateCurrentItems();

    this.changeDetectorRef.detectChanges();
  }

  public calculateTotalPages(): void {
    this.totalPages = Math.ceil(this.items.length / this.itemsPerPage);
    this.totalPagesArray = Array.from({ length: this.totalPages }, (_, i) => i);
  }

  public updateCurrentItems(direction?: string): void {
    this.animateForward = false;
    this.animateBackward = false;
    const startIndex = this.currentPage * this.itemsPerPage;
    this.currentItems = this.items.slice(startIndex, startIndex + this.itemsPerPage);
    if (direction) {
      this.triggerAnimation(direction);
    }
  }

  public goToPage(page: number): void {
    this.currentPage = page;
    this.updateCurrentItems();
  }

  public nextPage(): void {
    if (this.currentPage < this.totalPagesArray.length - 1) {
      this.currentPage++;
      this.updateCurrentItems(CarouselDirection.Forward);
    }
  }

  public previousPage(): void {
    if (this.currentPage > 0) {
      this.currentPage--;
      this.updateCurrentItems(CarouselDirection.Backward);
    }
  }

  public triggerAnimation(direction: string): void {
    if (direction === CarouselDirection.Forward) {
      setTimeout(() => {
        this.animateForward = true;
        this.changeDetectorRef.detectChanges();
      }, 0);
    } else if (direction === CarouselDirection.Backward) {
      setTimeout(() => {
        this.animateBackward = true;
        this.changeDetectorRef.detectChanges();
      }, 0);
    }
  }

  public startAutoplay(): void {
    if(this.useAutoplay) {
      if (!this.isAutoplay) {
        this.isAutoplay = true;
        this.autoplayInterval = setInterval(() => {
          this.nextPage();
          if (this.currentPage === this.totalPagesArray.length - 1) {
            this.currentPage = 0;
            this.updateCurrentItems();
          }
        }, this.autoplayDelay);
      }
    }
  }

  public stopAutoplay(): void {
    if (this.isAutoplay) {
      clearInterval(this.autoplayInterval);
      this.isAutoplay = false;
    }
  }

  public selectCard(item: any): void {
    this.selectedItem.emit(item);
  }

  prefillForm(cardInfo: any) {
    if (this.isWithinAddRiskModal) {
      this.selectedPrefilledCard && (this.selectedPrefilledCard.id === cardInfo.item.id)
        ? this.selectedPrefilledCard = null : this.selectedPrefilledCard = cardInfo.item;

    }

    this.prefillFormEvent.emit(cardInfo);
  }
}
